<template>
    <form-row title="Agreed-upon Purchase Price">
        <div class="flex flex-1 justify-between -mt-4">
            <div class="w-56">
                <input-money
                    name="purchase_price"
                    v-model="purchase_price"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
    },

    computed: {
        purchase_price: {
            get() {
                return store.state.purchase_price || null;
            },
            set(val) {
                store.state.purchase_price = val;
            },
        },
    },
}
</script>
